export function createFormikAction(type) {
  const action = (values, callback) => ({ callback, type, payload: values });
  action.REQUEST = type;
  return action;
}
